<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>account_balance</mat-icon></div>
          <mat-card-title>
            Contas Correntes
            <span class="cf-form-id" *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando" class="cc-hint cc-hint--info">Carregando conta corrente...</p>

        <form *ngIf="formulario && !carregando" [formGroup]="formulario" (ngSubmit)="submit()" class="cc-form">
          <section class="cc-bloco">
            <h3 class="cc-secao">Identificação</h3>
            <div class="row">
              <div class="col-12 col-md-5">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nome apresentação no sistema</mat-label>
                  <input matInput formControlName="descricao" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Situação</mat-label>
                  <mat-select formControlName="ativa">
                    <mat-option [value]="true">Ativa</mat-option>
                    <mat-option [value]="false">Inativa</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Data abertura</mat-label>
                  <input matInput type="date" formControlName="dataAbertura">
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="cc-bloco">
            <h3 class="cc-secao">Dados da conta</h3>
            <div class="row">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo conta corrente / caixa</mat-label>
                  <mat-select formControlName="tipoConta" required>
                    <mat-option *ngFor="let t of tiposConta" [value]="t">{{ descricaoTipoConta.get(t) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Banco</mat-label>
                  <mat-select formControlName="banco" required (selectionChange)="onBancoChange($event.value)">
                    <mat-option *ngFor="let b of bancos" [value]="b.codigo">{{ b.codigoFebraban }} — {{ b.nome }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Cód. FEBRABAN</mat-label>
                  <input matInput formControlName="codigoBanco" readonly>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Agência</mat-label>
                  <input matInput formControlName="agencia">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>CNAB</mat-label>
                  <mat-select formControlName="cnab">
                    <mat-option *ngFor="let c of padroesCnab" [value]="c">{{ c }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Conta corrente / caixa</mat-label>
                  <input matInput formControlName="numeroConta">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-1">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Dígito</mat-label>
                  <input matInput formControlName="digitoConta" maxlength="2">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Carteira</mat-label>
                  <input matInput formControlName="carteira">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Variação carteira</mat-label>
                  <input matInput formControlName="variacaoCarteira">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Convênio</mat-label>
                  <input matInput formControlName="convenio">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Cód. transmissão</mat-label>
                  <input matInput formControlName="codigoTransmissaoRemessa">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Código cedente</mat-label>
                  <input matInput formControlName="codigoCedente">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-1">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Díg.</mat-label>
                  <input matInput formControlName="digitoCedente" maxlength="2">
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="cc-bloco" *ngIf="bancoSelecionadoSuportaApi()">
            <h3 class="cc-secao">Credenciais API</h3>
            <p class="cc-hint">URLs definidas automaticamente pelo banco selecionado.</p>
            <p class="cc-hint" *ngIf="!bancoExigeClientSecret()">No Sicoob, informe apenas o Client ID (não há Client Secret).</p>
            <div class="row">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nº contrato cobrança</mat-label>
                  <input matInput formControlName="numeroContrato">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nº conta corrente (API)</mat-label>
                  <input matInput type="number" formControlName="numeroContaCorrente">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Client ID</mat-label>
                  <input matInput formControlName="clientId">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Chave PIX (Sicoob)</mat-label>
                  <input matInput formControlName="chavePix"
                    placeholder="E-mail, CPF/CNPJ, telefone ou chave aleatória cadastrada no banco">
                </mat-form-field>
                <small class="cc-hint">Não use o Client ID — informe a chave PIX da conta no Sicoob.</small>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nome do recebedor no PIX</mat-label>
                  <input matInput formControlName="nomeRecebedorPix" maxlength="25"
                    placeholder="Ex.: WOW SOFTWARES LTDA">
                </mat-form-field>
                <small class="cc-hint">Nome exibido ao pagar (máx. 25 caracteres). Atualize também no cadastro da chave PIX no Sicoob.</small>
              </div>

              <div class="col-12">
                <small class="cc-hint">
                  Encargos do PIX: cobrados automaticamente pelo banco apenas se o pagamento ocorrer após o vencimento.
                </small>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo da multa</mat-label>
                  <mat-select formControlName="multaTipo">
                    <mat-option [value]="null">Sem multa</mat-option>
                    <mat-option value="VALOR_FIXO">Valor fixo (R$)</mat-option>
                    <mat-option value="PERCENTUAL">Percentual (%)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>{{ formulario.value.multaTipo === 'PERCENTUAL' ? 'Multa (%)' : 'Multa (R$)' }}</mat-label>
                  <input matInput type="number" min="0" step="0.01" formControlName="multaValor">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo dos juros</mat-label>
                  <mat-select formControlName="jurosTipo">
                    <mat-option [value]="null">Sem juros</mat-option>
                    <mat-option value="VALOR_FIXO">Valor fixo (R$)</mat-option>
                    <mat-option value="PERCENTUAL">Percentual ao mês (%)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>{{ formulario.value.jurosTipo === 'PERCENTUAL' ? 'Juros ao mês (%)' : 'Juros (R$)' }}</mat-label>
                  <input matInput type="number" min="0" step="0.01" formControlName="jurosValor">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3" *ngIf="bancoExigeClientSecret()">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Client Secret</mat-label>
                  <input matInput type="password" formControlName="clientSecret"
                    [placeholder]="possuiClientSecret ? 'Secret já configurado — informe só para alterar' : 'Obrigatório para boleto/PIX'">
                </mat-form-field>
                <small *ngIf="possuiClientSecret && !formulario.value.clientSecret" class="cc-hint">
                  Secret salvo no sistema. Deixe em branco para manter.
                </small>
              </div>
            </div>
            <div class="row cc-certificado">
              <div class="col-12 col-md-6">
                <label class="cc-upload-label">Certificado digital (.pfx)</label>
                <input type="file" accept=".pfx,.p12" (change)="onCertificadoSelecionado($event)">
                <small class="cc-hint" *ngIf="possuiCertificado && !certificadoArquivo">
                  Certificado anexado: {{ nomeCertificado || 'arquivo salvo' }}. Selecione outro .pfx para substituir.
                </small>
                <small class="cc-hint" *ngIf="!possuiCertificado">
                  Obrigatório para autenticação mTLS no Sicoob (token, boleto e PIX).
                </small>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Senha do certificado</mat-label>
                  <input matInput type="password" formControlName="senhaCertificado"
                    [placeholder]="possuiCertificado ? 'Informe só para alterar' : 'Senha do arquivo .pfx'">
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="cc-bloco">
            <h3 class="cc-secao">Parametrizações remessa</h3>
            <div class="row">
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nº remessa/retorno</mat-label>
                  <input matInput type="number" formControlName="numeroRemessaRetorno">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Nº remessa CP</mat-label>
                  <input matInput type="number" formControlName="numeroRemessaRetornoContaPagar">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Dias baixa auto.</mat-label>
                  <input matInput type="number" formControlName="qtdDiasBaixarBoletoRegistrado">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Dias máx. remessa</mat-label>
                  <input matInput type="number" formControlName="qtdDiasMaxFiltrarRemessa">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Dias a vencer</mat-label>
                  <input matInput type="number" formControlName="qtdDiasConsiderarBoletoAVencer">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Espécie título</mat-label>
                  <input matInput formControlName="especieTituloBoleto">
                </mat-form-field>
              </div>
            </div>
            <div class="cc-grid cc-grid--toggles">
              <mat-slide-toggle formControlName="carteiraRegistrada">Carteira registrada</mat-slide-toggle>
              <mat-slide-toggle formControlName="permitirEmissaoBoletoVencido">Permitir boleto vencido</mat-slide-toggle>
              <mat-slide-toggle formControlName="permiteEnviarBoletoVencidoRemessa">Enviar vencido (remessa)</mat-slide-toggle>
              <mat-slide-toggle formControlName="emissaoBoletoPeloBanco">Emissão pelo banco</mat-slide-toggle>
              <mat-slide-toggle formControlName="utilizaAbatimentoTaxasRepasse">Abatimento taxas repasse</mat-slide-toggle>
              <mat-slide-toggle formControlName="gerarRemessaSemDescontoAbatido">Remessa sem desconto abatido</mat-slide-toggle>
              <mat-slide-toggle formControlName="habilitarRegistroRemessaOnline">Registro remessa online</mat-slide-toggle>
              <mat-slide-toggle formControlName="enviarRemessaApenasBoletoImpresso">Só boleto impresso</mat-slide-toggle>
              <mat-slide-toggle formControlName="gerarContaPagarTaxasBancarias">Gerar CP taxas bancárias</mat-slide-toggle>
            </div>
            <div class="row cc-grid--top">
              <div class="col-12 col-md-6">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Forma pagamento padrão taxas</mat-label>
                  <input matInput formControlName="formaPagamentoPadraoTaxas">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Categoria despesa padrão taxas</mat-label>
                  <input matInput formControlName="categoriaDespesaPadraoTaxas">
                </mat-form-field>
              </div>
            </div>
          </section>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid">
              <mat-icon>save</mat-icon> {{ editando ? 'Atualizar' : 'Salvar' }}
            </button>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</main>
